import { ViewValue } from '@resparke/models';

export enum FormControls {
  SELECT = 'SELECT',
  AUTOCOMPLETE = 'AUTOCOMPLETE',
  TEXTAREA = 'TEXTAREA',
  TEXT = 'TEXT',
  DATE = 'DATE',
  AUTOCOMPLETE_CHIP = 'AUTOCOMPLETE_CHIP',
  CHIP_INPUT = 'CHIP_INPUT',
  TOGGLE = 'TOGGLE',
  CHIPS = 'CHIPS',
  TEXTAREA_ADD = 'TEXTAREA_ADD',
  GRID_ADD = 'GRID_ADD',
  IMAGE = 'IMAGE',
  HIDDEN = 'HIDDEN',
  YEAR = 'YEAR'
}

export interface BaseField {
  label?: string;
  name: string;
  type: FormControls;
  defaultValue?: any;
  required?: boolean;
  disableEdit?: boolean;
  hideError?: boolean;
  subscriptSizing?: 'dynamic' | 'fixed';
  appearance?: 'fill' | 'outline';
  placeholder?: string;
}

export interface SelectField extends BaseField {
  type: FormControls.SELECT;
  options: ViewValue[];
}

export interface TextField extends BaseField {
  type: FormControls.TEXT;
}

export interface TextArea extends BaseField {
  type: FormControls.TEXTAREA;
  maxLength: number;
  showCount: boolean;
  rows: number;
}
export interface TextAreaAdd extends BaseField {
  type: FormControls.TEXTAREA_ADD;
  maxLength: number;
  showCount: boolean;
  rows: number;
  defaultValue: string[];
  textAddIcon: string;
  textItemIcon: string;
  editable: boolean;
}

export interface DateField extends BaseField {
  type: FormControls.DATE;
}
export interface YearField extends BaseField {
  type: FormControls.YEAR;
}
export interface AutocompleteField extends BaseField {
  type: FormControls.AUTOCOMPLETE;
  options: ViewValue[];
  creatable?: boolean;
  icon?: string;
}

export interface AutocompleteChipsField extends BaseField {
  type: FormControls.AUTOCOMPLETE_CHIP;
  options: ViewValue[];
  creatable?: boolean;
  icon?: string;
}

export interface ChipInputField extends BaseField {
  type: FormControls.CHIP_INPUT;
}

export interface ToggleField extends BaseField {
  type: FormControls.TOGGLE;
  text: string;
  toggleTextTrue: string;
  toggleTextFalse: string;
}
export interface ChipsField extends BaseField {
  type: FormControls.CHIPS;
  multiple: boolean;
  options: ViewValue[];
}

export interface GridAdd extends BaseField {
  type: FormControls.GRID_ADD;
  defaultValue: string[];
  textAddIcon: string;
  textItemIcon: string;
  columns: any[];
}

export interface Image extends BaseField {
  type: FormControls.IMAGE;
  defaultValue: string[];
  accepts: string[];
  multiple: boolean;
  maxFileCount: number;
  icon: string;
  maxFileSize: number;
}

export interface Hidden extends BaseField {
  type: FormControls.HIDDEN
}

export type fields = SelectField |
  TextField |
  TextArea |
  DateField |
  YearField |
  AutocompleteField |
  AutocompleteChipsField |
  ChipInputField |
  ToggleField |
  ChipsField |
  TextAreaAdd |
  GridAdd |
  Image |
  Hidden;


  export enum FORM_STATE {
    RESTING = 'RESTING',
    LOADING = 'LOADING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
  }
